import { render, staticRenderFns } from "./keyword-search.vue?vue&type=template&id=0141483c&scoped=true"
import script from "./keyword-search.vue?vue&type=script&lang=js"
export * from "./keyword-search.vue?vue&type=script&lang=js"
import style0 from "./keyword-search.vue?vue&type=style&index=0&id=0141483c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0141483c",
  null
  
)

export default component.exports